export const SET_PROGRAM = "SET_PROGRAM";
export const SET_PROGRAM_LOADED = "SET_PROGRAM_LOADED";
export const SET_TYPE_CORETIER = "SET_TYPE_CORETIER";
export const SET_TYPE_PLUSTIER = "SET_TYPE_PLUSTIER";
export const SET_TYPE_PROTIER = "SET_TYPE_PROTIER";
export const SET_TYPE_ACTIVATEPRODUCT = "SET_TYPE_ACTIVATEPRODUCT";
export const SET_TYPE_ENGAGEPRODUCT = "SET_TYPE_ENGAGEPRODUCT";
export const SET_TYPE_THRIVEPRODUCT = "SET_TYPE_THRIVEPRODUCT";
export const SET_TYPE_WELLNESS = "SET_TYPE_WELLNESS";
export const SET_TYPE_ACTIVITY = "SET_TYPE_ACTIVITY";
export const SET_LOADED_STATUS = "SET_LOADED_STATUS";
export const UPDATE_META_VALUE = "UPDATE_META_VALUE";
export const UPDATE_SETTINGS_COPY_VALUE = "UPDATE_SETTINGS_COPY_VALUE";
export const ENABLE_BADGES = "ENABLE_BADGES";

export const SET_MAPS = "SET_MAPS";

export const SET_PROGRAM_TEAMS = "SET_PROGRAM_TEAMS";
export const SET_PROGRAM_TEAMS_RESPONSE_OBJECT =
  "SET_PROGRAM_TEAMS_RESPONSE_OBJECT";
export const REMOVE_PROGRAM_TEAM = "REMOVE_PROGRAM_TEAM";
export const ADD_PROGRAM_TEAM = "ADD_PROGRAM_TEAM";
export const UPDATE_PROGRAM_TEAM = "UPDATE_PROGRAM_TEAM";

export const SET_MEMBERS_RESPONSE_OBJECT = "SET_MEMBERS_RESPONSE_OBJECT";
export const SET_ADMIN_MEMBERS_RESPONSE_OBJECT =
  "SET_ADMIN_MEMBERS_RESPONSE_OBJECT";

export const SET_MEMBERS = "SET_MEMBERS";
export const REMOVE_MEMBER = "REMOVE_MEMBER";
export const ADD_MEMBER = "ADD_MEMBER";

export const SET_CHALLENGES = "SET_CHALLENGES";
export const SET_ALL_CHALLENGES = "SET_ALL_CHALLENGES";
export const SET_FEATURED_CHALLENGE = "SET_FEATURED_CHALLENGE";
export const SET_FEATURED_CHALLENGES = "SET_FEATURED_CHALLENGES";
export const SET_ALL_FEATURED_CHALLENGES = "SET_ALL_FEATURED_CHALLENGES";
export const SET_ACTIVE_CHALLENGES = "SET_ACTIVE_CHALLENGES";
export const SET_PENDING_CHALLENGES = "SET_PENDING_CHALLENGES";
export const SET_ARCHIVED_CHALLENGES = "SET_ARCHIVED_CHALLENGES";
export const REMOVE_ARCHIVED_CHALLENGE = "REMOVE_ARCHIVED_CHALLENGE";

export const SET_ACTIVITIES = "SET_ACTIVITIES";

export const RESET_JOURNALS = "RESET_JOURNALS";
export const IS_JOURNAL_LAST_PAGE = "IS_JOURNAL_LAST_PAGE";
export const SET_JOURNALS = "SET_JOURNALS";

export const SET_STEP_DATA = "SET_STEP_DATA";
export const SET_LEADERBOARD = "SET_LEADERBOARD";

export const SET_AGGREGATE_DATA = "SET_AGGREGATE_DATA";

export const SET_PROGRAM_QUESTIONS = "SET_PROGRAM_QUESTIONS";
export const ADD_PROGRAM_QUESTION = "ADD_PROGRAM_QUESTION";
export const UPDATE_PROGRAM_QUESTION = "UPDATE_PROGRAM_QUESTION";
export const UPDATE_PROGRAM_QUESTIONS = "UPDATE_PROGRAM_QUESTIONS";
export const REMOVE_PROGRAM_QUESTION = "REMOVE_PROGRAM_QUESTION";
export const SET_INCENTIVE_INTEGRATION = "SET_INCENTIVE_INTEGRATION";
export const SET_PROGRAM_ORGANIZATIONS = "SET_PROGRAM_ORGANIZATIONS";
